import countries from 'mui/assets/data/countries';

const getLocaleData = () =>
  Object.entries(countries).reduce(
    (allLocaleData, [locale, { shortName, url }]) => {
      if (locale === process.env.GATSBY_COUNTRY_CODE)
        allLocaleData.default = {
          name: shortName,
          url,
        };
      else
        allLocaleData.rest[locale] = {
          name: shortName,
          url,
        };

      return allLocaleData;
    },
    {
      default: {},
      rest: {},
    },
  );

export default getLocaleData;
